import { computed, ref } from 'vue'
import { enums } from '@app/state/enums/enums'
import { createData } from './partials/data'
import { createForm, applyFormSubmissionApiCallback } from './partials/form'
import { createProgression, applyProgressionApiCallback } from './partials/progression'
import { createDataWatches, createFormFieldWatches } from './partials/helpers/watches/watches'

/**
 * Create sections for the membership state
 */
const data = createData()
const progression = createProgression()
const form = createForm()

/**
 * Create watches for the data APIs details
 */
createDataWatches(data, form)

/**
 * Create watches for the form fields
 */
createFormFieldWatches(data, form, progression)

/**
 * Controls showing the details step vs the data accordion step
 */
const section = ref('form')

/**
 * Apply callbacks for the state sections which require different parts of the state
 */
applyProgressionApiCallback(progression, form, section, data)
applyFormSubmissionApiCallback(form, progression, data.membership_type, data.answers)

enums.payment_details.payment_type.config.value.onDataReceived = (response) => ({
    ...response.payment_types,
    data: response.payment_types.data.filter(
        (paymentType) => data.pricing.has_availability_for_payment_type(paymentType.value)
    )
})

const state = {
    /**
     * Objects for the different sections of the state
     */
    data: data,
    enums: enums,
    form: form,
    progression: progression,

    /**
     * Which section of the signup process we're viewing
     * (Ref, either details of form)
     */
    section: section,

    /**
     * Used to render the different steps between details vs form
     */
    formContainers: {
        columnClass: computed(
            () => section.value === 'details'
                ? undefined
                : 'grid-cols-1 sm:grid-cols-2'
        ),
        columnWrapper: computed(
            () => section.value === 'details'
                ? undefined
                : 'div'
        )
    },

    /**
     * Callback to store the progress so we can append the correct data to the details API
     */
    onStoreProgress: () => {
        progression.actions.submit.api.parameters.value = {
            ...progression.details.value,
            redirect: window.location.href,
            answers: {
                _position: {
                    section: section.value,
                    current_step: form.steps.current_stage.value,
                    highest_step: form.steps.highest_stage.value,
                },
                ...form.fields.value
            }
        }

        progression.actions.submit.api.execute()
    }
}

export default state

/**
 * So we can access these parts of the state independently inside the different steps
 */
export {
    data,
    form,
    enums
}
